import { createContext, Dispatch, SetStateAction } from 'react'

import { CommonFormContextProps } from 'components/Form'
import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'

export const DefaultsContext = createContext<DefaultsContextType>({} as DefaultsContextType)

export type DefaultsContextType = CommonFormContextProps & {
  prebidStack?: {
    setWorkspaceConfig: Dispatch<SetStateAction<undefined | WorkspacePrebidConfiguration>>
    workspaceConfig?: WorkspacePrebidConfiguration
  }
}
